import React, { useState, useEffect, cloneElement } from "react"
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    useDisclosure
} from '@chakra-ui/react'


export default function EditModal({ children, itemToEdit, headingText }) {
    const { isOpen, onOpen, onClose } = useDisclosure()

    useEffect(() => {
        if (itemToEdit) onOpen()
    }, [itemToEdit])

    const enhancedChildren = React.Children.map(children, child => {
        return cloneElement(child, { editModalOnClose: onClose })
    })

    return (
        <>
            <Modal
                isOpen={isOpen}
                onClose={onClose}
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>{headingText}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {enhancedChildren}
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    )
}
